import { useState } from 'react';
import moment from 'moment';
import oktaIco from './OktaLogo.ico';
import notFound from './not_found.svg';

function CommentSection({ handleEditComment }) {
  // useState hook to store the list of comments and a function to update it
  const [comments, setComments] = useState([
    {
      id: 1,
      user: 'Okta Solutions',
      userId: 2318,
      avatar: oktaIco,
      date: new Date(),
      text: 'Ovo je neki komentar sa malo vecim tekstom, ovde ima nesto aaakdoe kkd pepfl kkk kego idako flepf iidko ppdeo mmmla ofke lllde dadj.',
    },
    {
      id: 2,
      user: 'Matije Vuković',
      userId: 2,
      avatar: 'https://via.placeholder.com/50x50',
      date: new Date(),
      text: 'Ok',
    },
    {
      id: 3,
      user: 'Matije Vuković',
      userId: 2,
      avatar: 'https://via.placeholder.com/50x50',
      date: new Date(),
      text: 'Drugi komentar.',
    },
    {
      id: 4,
      user: 'Matije Vuković',
      userId: 2,
      avatar: 'https://via.placeholder.com/50x50',
      date: new Date(),
      text: 'Neki treci komentar',
    },
    {
      id: 5,
      user: 'Okta Solutions',
      userId: 2318,
      avatar: oktaIco,
      date: new Date(),
      text: 'Proba test komentar.',
    },
    {
      id: 6,
      user: 'Matije Vuković',
      userId: 2,
      avatar: 'https://via.placeholder.com/50x50',
      date: new Date(),
      text: 'Jos jedan komentar da se pojavi skrol, overflow je auto!',
    },
  ]);

  // function to handle deleting a comment
  const handleDeleteComment = (id) => {
    // create a new copy of the comments array, excluding the comment with the matching id
    const newComments = comments.filter((comment) => comment.id !== id);
    // update the state with the new comments array
    setComments(newComments);
  };

  return (
    <div className="scrollable-list">
      {comments.length > 0 ? (
        comments.map((comment) => (
          <div key={comment.id} className="comment-section">
            <div className="comment">
              <img src={comment.avatar} alt={comment.user} className="avatar" />
              <div className="content">
                <div className="info">
                  <span className="user">{comment.user}</span>
                  <span className="date">
                    {moment(comment.date).format('LLL')}
                  </span>
                </div>
                <div className="text">{comment.text}</div>
              </div>
            </div>
            {comment.userId === +localStorage.idKorisnika && (
              <div className="comment-actions">
                <button
                  title="Izmeni komentar"
                  onClick={() => handleEditComment(comment)}
                >
                  <i style={{ color: '#03a9f4' }} className="fas fa-edit" />
                </button>
                <button
                  title="Obriši komentar"
                  onClick={() => handleDeleteComment(comment.id)}
                >
                  <i style={{ color: '#e0515f' }} className="fas fa-trash" />
                </button>
              </div>
            )}
          </div>
        ))
      ) : (
        <div style={{ width: '120px', height: '30%' }}>
          <img src={notFound} alt="not found" width="100%" height="100%" />
          <p style={{ textAlign: 'center' }}>Još uvek nema komentara.</p>
        </div>
      )}
    </div>
  );
}

export default CommentSection;
